import { combineReducers } from 'redux'
import user from './user'

const root = combineReducers({
  user,
})

export default root
